import React from 'react';

import FeedHeading from 'buyside/components/presentation/Feed/FeedHeading/feedHeading';
import HighlightedMentions from 'buyside/components/presentation/Feed/HighlightedMentions/highlightedMentions';
import HighlightedRanking from 'buyside/components/presentation/Feed/HighlightedRanking/highlightedRanking';
import ResearchItem, {
  ResearchTypes
} from 'buyside/components/presentation/ResearchItem/researchItem';
import YouTubePlayer from 'buyside/components/presentation/YouTubePlayer/youtubePlayer';

import { ActivityFeedWhitePaperFragment } from 'interfaces/graphql-typings';
import { FeedItemComponentType } from 'interfaces/feed/feedItems';

import styles from './whitePaperStyles.scss';

const WhitePaperFeedItem: React.FC<{
  whitePaper: ActivityFeedWhitePaperFragment;
} & FeedItemComponentType> = ({ currentUser, eventVerb, shouldHighlightMention, whitePaper }) => {
  if (!currentUser || !whitePaper) return null;

  const author = whitePaper.wpUser;
  const isCurrentUser = author.id === currentUser?.id;

  return (
    <>
      {eventVerb === 'PUBLISH_WHITE_PAPER' && (
        <div className={styles.feedItemHeader}>
          {shouldHighlightMention && <HighlightedMentions />}
          {author.isRanked && <HighlightedRanking />}
          <FeedHeading
            headerType={eventVerb}
            showUserDetails={currentUser?.canViewUserDetails || isCurrentUser}
            user={author}
            idea={null}
            createdAt={null}
          />
        </div>
      )}
      <div className={styles.whitePaperResearchItem}>
        <ResearchItem
          {...whitePaper}
          elevatorPitch={whitePaper.wpElevatorPitch}
          updatedAt={whitePaper.wpUpdatedAt}
          user={author}
          researchType={ResearchTypes.WHITE_PAPER}
          showUserDetails={currentUser?.canViewUserDetails || isCurrentUser}
        />
      </div>
      {whitePaper.youtubeIds &&
        whitePaper.youtubeIds.map(id => <YouTubePlayer key={id} height={351} videoId={id} />)}
    </>
  );
};

export default WhitePaperFeedItem;
